import React from "react";

import { forwardRef, type HTMLAttributes } from "react";
import clsx from "clsx";
import styles from "./card.module.css";

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  variant?: "default" | "subtle" | "strong";
  hover?: boolean;
  glow?: boolean;
  padding?: "none" | "3xl" | "5xl" | "7xl";
}

const paddingMap = {
  none: "",
  "3xl": "p3xl",
  "5xl": "p5xl",
  "7xl": "p7xl",
} as const;

export const Card = forwardRef<HTMLDivElement, CardProps>(
  (
    {
      className,
      variant = "default",
      hover = false,
      glow = false,
      padding = "3xl",
      children,
      ...props
    },
    ref,
  ) => {
    return (
      <div
        ref={ref}
        className={clsx(
          styles.cardSection,
          styles.border,
          styles[paddingMap[padding]],
          {
            [styles.glassDefault]: variant === "default",
            [styles.glassSubtle]: variant === "subtle",
            [styles.glassStrong]: variant === "strong",
            [styles.glassHover]: hover,
            [styles.glassGlow]: glow,
          },
          className,
        )}
        {...props}
      >
        {children}
      </div>
    );
  },
);

Card.displayName = "Card";
